import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formatTimestamp', standalone: true })
export class FormatTimestampPipe implements PipeTransform {
  transform(value: any, spaceColon: boolean = false, removeLeadingZeros: boolean = false): string {
    const seconds = this.parseSeconds(value);
    if (isNaN(seconds)) {
      return '-';
    }
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const colon = spaceColon ? ' ' : ':';
    return `${this.formatNumber(minutes, removeLeadingZeros)}m${colon}${this.formatNumber(remainingSeconds, removeLeadingZeros)}s`;
  }

  private parseSeconds(value: any): number {
    if (typeof value === 'string') {
      value = value.trim();
    }
    const num = typeof value === 'string' ? parseInt(value, 10) : value;
    return isNaN(num) ? NaN : num;
  }

  private formatNumber(num: number, removeLeadingZeros: boolean): string {
    if (removeLeadingZeros) {
      return num.toString();
    }
    return num < 10 ? '0' + num : num.toString();
  }
}
